import React from 'react';
import theme from '../../theme';

// Dropdown of checkboxes in titled groups; `indent` nests an option under the one above.
// Open state lives in the page, so opening one closes the others.
// `align` is the side the dropdown is pinned to: 'right' opens leftwards, 'left' rightwards.
// `buttonClass` sizes the trigger; the default is the compact Favorites pill.
function MultiSelect({
  label, groups, value, onChange, open, onOpenChange, align = 'right', buttonClass = 'px-3 py-1.5 text-xs',
}) {
  const toggle = (o) => onChange(value.includes(o) ? value.filter((v) => v !== o) : [...value, o]);
  const labelOf = Object.fromEntries(groups.flatMap((g) => g.options).map((o) => [o.value, o.label]));
  const empty = groups.every((g) => g.options.length === 0);
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => onOpenChange(!open)}
        aria-expanded={open}
        className={`h-full rounded-lg ${buttonClass} font-medium ${value.length ? theme.pillActive : theme.pillInactive} ${theme.pillContainer}`}
      >
        {label}{value.length ? `: ${value.map((v) => labelOf[v] || v).join(', ')}` : ''}
      </button>
      {open && (
      <div className={`absolute ${align === 'left' ? 'left-0' : 'right-0'} z-20 mt-1 max-h-96 min-w-[12rem] overflow-y-auto rounded-xl border border-olive-100 bg-white p-2 shadow-lg`}>
        {empty && <p className={`px-1 text-xs ${theme.textMuted}`}>Nothing to pick</p>}
        {groups.filter((g) => g.options.length).map((g, i) => (
          <div key={g.title || i} className={i ? 'mt-2 border-t border-olive-100 pt-2' : ''}>
            {g.title && <p className={`px-1 pb-1 text-[10px] font-bold uppercase tracking-wider ${theme.textMuted}`}>{g.title}</p>}
            {g.options.map((o) => (
              <label key={o.value} className={`flex cursor-pointer items-center gap-2 rounded px-1 py-1 text-xs hover:bg-olive-50 ${o.indent ? 'pl-5' : ''}`}>
                <input type="checkbox" checked={value.includes(o.value)} onChange={() => toggle(o.value)} />
                {o.label}
              </label>
            ))}
          </div>
        ))}
        {value.length > 0 && (
          <button type="button" onClick={() => onChange([])} className="mt-1 w-full rounded px-1 py-1 text-left text-[11px] text-rose-500 hover:bg-rose-50">
            Clear
          </button>
        )}
      </div>
      )}
    </div>
  );
}

// Plain list of strings as one untitled group.
export const plain = (options) => [{ options: options.map((o) => ({ value: o, label: o })) }];

export default MultiSelect;
